"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _ChatCategory = require("@/lib/enum/ChatCategory");
var _chatQuery = require("@/apollo/queries/chat-query");
var _chatMutation = require("@/apollo/mutations/chat-mutation");
var _default = exports.default = {
  methods: {
    getChatUsers: function () {
      var _getChatUsers = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(isAdmin) {
        var data;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return _apolloClient.apolloClient.query({
                query: _chatQuery.CHAT_USERS_BY_IS_ADMIN_QUERY,
                variables: {
                  isAdmin: isAdmin
                },
                fetchPolicy: 'no-cache'
              }).catch(function (error) {
                return Promise.reject(error);
              });
            case 1:
              data = _context.sent;
              return _context.abrupt("return", Promise.resolve(data.data.chat_user));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getChatUsers(_x) {
        return _getChatUsers.apply(this, arguments);
      }
      return getChatUsers;
    }(),
    insertChatRoom: function () {
      var _insertChatRoom = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(chatAdmin, admin) {
        var chatUsers, adminChatUsers, roomMemberAdmin, insertObj;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return this.getChatUsers(false);
            case 1:
              chatUsers = _context2.sent;
              if (chatUsers.length) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", Promise.resolve('noUser'));
            case 2:
              _context2.next = 3;
              return this.getChatUsers(true);
            case 3:
              adminChatUsers = _context2.sent;
              roomMemberAdmin = adminChatUsers.filter(function (val) {
                return val.uid !== chatAdmin.uid;
              }).map(function (val) {
                return {
                  user_id: val.uid
                };
              });
              insertObj = chatUsers.map(function (usr) {
                var roomMembers = Array.from(roomMemberAdmin);
                roomMembers.push({
                  user_id: usr.uid
                }, {
                  user_id: chatAdmin.uid
                });
                return {
                  chat_room_name: chatAdmin.name,
                  owner_id: usr.uid,
                  chat_room_category_id: _ChatCategory.ChatCategory.Work.val,
                  admin_user_id: chatAdmin.uid,
                  chat_room_sub_category_id: _ChatCategory.ChatCategory.Work.SubCategory.Charge.val,
                  thumbnail: admin.avatar,
                  room_members: {
                    data: roomMembers,
                    on_conflict: {
                      constraint: 'room_member_chat_room_id_user_id_key',
                      update_columns: []
                    }
                  }
                };
              });
              console.log(insertObj);
              _context2.next = 4;
              return _apolloClient.apolloClient.mutate({
                mutation: _chatMutation.INSERT_CHAT_ROOM,
                variables: {
                  objects: insertObj
                }
              }).then(function (result) {
                console.log('insertChatRoomResolve');
                return Promise.resolve(result);
              }).catch(function (error) {
                console.log('insertChatRoomReject');
                return Promise.reject(error);
              });
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function insertChatRoom(_x2, _x3) {
        return _insertChatRoom.apply(this, arguments);
      }
      return insertChatRoom;
    }()
  }
};